module.exports = "<div> <div class=mui-group-title v-if=title :style={color:titleColor}>{{title}}</div> <div class=mui-group :class=\"{'no-group-title':!title, 'mui-group-item-access':access}\"> <slot></slot> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/group/index.vue
 ** module id = 162
 ** module chunks = 0
 **/